import {
  type Dispatch,
  type PropsWithChildren,
  type ReactElement,
  useState,
} from 'react';
import { ToggleOverlayBtn } from './ToggleOverlayBtn';

type TOverlayPanelWrapperProps = PropsWithChildren & {
  renderOverlayPanel: (
    open: boolean,
    setOpen: Dispatch<boolean>
  ) => ReactElement;
  defaultOpen?: boolean;
};

export const OverlayPanelWrapper = ({
  children,
  renderOverlayPanel,
  defaultOpen = false,
}: TOverlayPanelWrapperProps) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <>
      <ToggleOverlayBtn onClick={() => setOpen(true)}>
        {children}
      </ToggleOverlayBtn>
      {renderOverlayPanel(open, setOpen)}
    </>
  );
};
